import React from "react";
import { BaseResolver, BaseResolverProps } from "./BaseResolver";
import { useTranslations } from "use-intl";
export const FormResolver = (props: Omit<BaseResolverProps, "type">) => {
  const t = useTranslations();
  return <BaseResolver {...props} type="form" placeholder={t("placeholder_chooseForm_20230807143005")} data-sentry-element="BaseResolver" data-sentry-component="FormResolver" data-sentry-source-file="FormResolver.tsx" />;
};